import {defineStore} from 'pinia'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import {useAppStore} from '@/stores/appStore'

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        groups: [],
        components: [],
        openGroupName: undefined,
        open: false
    }),
    
    actions: {
        init() {
            this.setGroups()
            this.setGroupsComponents()
        },
        
        setGroups() {
            const appStore = useAppStore()
            const componentsStore = useComponentsStore()
            const betaMode = appStore.betaMode
            
            if (componentsStore.items) {
                let groups = [
                    'Website',
                    'eCommerce',
                    'Add ons',
                    'Marketing',
                    'Forms',
                    'Themes',
                    'Modules',
                ]
                
                componentsStore.items.forEach((obj) => {
                    if (
                        !!obj.navigationGroup
                        && (!obj.devOnly || betaMode)
                    ) {
                        if (groups.indexOf(obj.navigationGroup) === -1) {
                            groups.push(obj.navigationGroup)
                        }
                    }
                })
                
                this.groups = groups
            }
        },
        
        setGroupsComponents() {
            const appStore = useAppStore()
            const componentsStore = useComponentsStore()
            const userStore = useUserStore()
            
            if (componentsStore.items) {
                const user = userStore.user ?? {}
                const betaMode = appStore.betaMode
                const pageEditorMode = appStore.pageEditorMode
                let components = []
                
                componentsStore.items.forEach((obj) => {
                    if (
                        !!obj.navigationGroup
                        && (!obj.devOnly || betaMode)
                    ) {
                        if (
                            user.administrator || (
                                user.access?.__formAdmin
                                && obj.navigationGroup === 'Forms'
                            )
                        ) {
                            components.push(obj)
                            return
                        }
                        
                        const privileges = userStore.access(obj.tableName)
                        if (privileges) {
                            let found = false
                            
                            // Check that each enabled option is enabled at the component level.
                            for (const privilege in privileges) {
                                if (!found) {
                                    switch (privilege) {
                                        case 'add':
                                            if (obj.addNew) found = true
                                            break
                                        case 'archive':
                                            if (obj.useArchive) found = true
                                            break
                                        case 'delete':
                                            if (obj.deleteOption) found = true
                                            break
                                        case 'edit':
                                            if (obj.updateOption) found = true
                                            break
                                        case 'publish':
                                            if (obj.showStatus) found = true
                                    }
                                }
                            }
                            
                            if (found) {
                                components.push(obj)
                            }
                        }
                    }
                })
                
                if (
                    components.find(o => o.tableName === 'pages')
                    && components.find(o => o.tableName === 'content')
                ) {
                    components.unshift({
                        title: 'Site tree',
                        tableName: 'site_tree',
                        navigationGroup: 'Website'
                    })
                    
                    if (pageEditorMode) {
                        components.unshift({
                            title: 'Editor',
                            tableName: 'editor',
                            navigationGroup: 'Website'
                        })
                    }
                }
                
                if (user.administrator) {
                    components.unshift({
                        title: 'Editor',
                        tableName: 'themes_editor',
                        navigationGroup: 'Themes',
                    })
                }
                
                this.components = components
            }
        }
    }
})